import { Box } from "@mui/material"
import type { FC } from "react"

import type { AdjustmentLotReference } from "../types"

import { ConfirmationDialog } from "@/components/common/Modals"

interface AdjustmentUntestedLotsConfirmationDialogProps {
  untestedLots: AdjustmentLotReference[]
  onClose: () => void
  onConfirm: () => void
}

export const AdjustmentUntestedLotsConfirmationDialog: FC<AdjustmentUntestedLotsConfirmationDialogProps> = ({
  untestedLots,
  onClose,
  onConfirm,
}) => (
  <ConfirmationDialog
    title='Lot Numbers Not Found'
    content={
      <Box>
        <p className='mb-4'>The following Lot Numbers were not found in Product Test Results:</p>
        <ul className='list-disc px-4 text-left font-normal'>
          {untestedLots.map((lot, index) => (
            <li
              key={`${lot.lotNumber}-${index}`}
              data-testid={`inventory.adjustment-untested-lots-confirmation-dialog.lot-${index}`}
            >
              Lot #<b>{lot.lotNumber}</b>
              {lot.batchNumber && (
                <>
                  , Batch #<b>{lot.batchNumber}</b>
                </>
              )}
            </li>
          ))}
        </ul>
      </Box>
    }
    closeLabel='Cancel'
    confirmLabel='Continue Anyway'
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
